require('./sections/orders');
require('./sections/app');
require('./auth/app');
require('./product/app');

require('../nmuk/core/app');